export default __webpack_public_path__ + "static/hotblack-tech-about1-e72081fa0c83b9ccce759d1cb48539b1.svg";